<template>
  <div class="g-content">
    <!-- 搜索 -->
    <div class="g-content-filter">
      <div class="g-content-filter-main">
        <h3>{{ $t('logs_error_title') }}</h3>
        <div class="g-content-filter-right">
          <a-form-model :model="searchForm" layout="inline" ref="formElement">
            <!-- 关键字 -->
            <a-form-model-item :label="null" prop="keyword">
              <a-input-search
                v-model="searchForm.keyword"
                style="min-width:200px"
                :placeholder="$t('com_form_keyword_input')"
                allowClear
                @search="getList()"
                @blur="getList()"
              />
            </a-form-model-item>

            <!-- 开始时间 -->
            <a-form-model-item :label="null" prop="date">
              <a-range-picker
                v-model="searchForm.date"
                show-time
                valueFormat="x"
                @openChange="
                  opened => {
                    if (!opened) {
                      this.getList();
                    }
                  }
                "
              />
            </a-form-model-item>

            <!-- 排序 -->
            <a-form-model-item :label="null" prop="orderField">
              <a-select
                v-model="searchForm.orderField"
                :placeholder="$t('com_form_order_field')"
                style="min-width:150px;"
                @change="getList()"
              >
                <a-select-option
                  :value="item.value"
                  v-for="(item, index) in $t('logs_error_order_field')"
                  :key="index"
                >
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>

            <!-- 排序 -->
            <a-form-model-item :label="null" prop="orderType">
              <a-select
                v-model="searchForm.orderType"
                :placeholder="$t('logs_order_type')"
                @change="getList()"
              >
                <a-select-option :value="1">
                  {{ $t('com_form_order_desc') }}
                </a-select-option>
                <a-select-option :value="0">
                  {{ $t('com_form_order_esc') }}
                </a-select-option>
              </a-select>
            </a-form-model-item>

            <!-- 提交 -->
            <a-form-model-item style="margin:0">
              <a-button type="primary" @click.prevent="getList()">
                {{ $t('com_btn_search') }}
              </a-button>
            </a-form-model-item>
          </a-form-model>
        </div>
      </div>
    </div>

    <div class="g-content-main common-filter-main">
      <div class="log-content">
        <Loading :show="true" v-if="loading" />
        <NetworkError v-else-if="networkError" />
        <div class="g-table" v-else>
          <a-table
            :columns="columns"
            :data-source="list"
            bordered
            rowKey="id"
            :pagination="false"
            :loading="tableLoading"
            size="small"
          >
            <!-- 状态 -->
            <template slot="faultStatus" slot-scope="text">
              <!-- 故障状态是否结束状态，0-open，1-ended -->
              <span v-if="text === 0">Open</span>
              <span v-if="text === 1">Ended</span>
            </template>

            <template slot="sn" slot-scope="text">
              <div class="g-table-text" style="min-width:50px">{{ text }}</div>
            </template>

            <!-- 类型 -->
            <template slot="faultType" slot-scope="text">
              <!-- 故障类型，0-断线，1-轻微告警，2-告警，部分设备不可用，3-故障，系统不可用 -->
              <span v-if="$t('system_dashboard_system_events_types')[text]">
                {{ $t('system_dashboard_system_events_types')[text] }}
              </span>
              <span v-else>--</span>
            </template>

            <!-- 执行数据 -->
            <template slot="executeData" slot-scope="text, record">
              <div class="g-table-text" v-if="text">
                <a-icon
                  type="copy"
                  data-clipboard-action="copy"
                  title="Copy"
                  style="color:#ccc"
                  :data-clipboard-text="`${text}`"
                  :id="`logs_error_event_${record.id}`"
                  @click="copyContent(`#logs_error_event_${record.id}`)"
                />{{ text }}
              </div>
            </template>

            <!-- 开始时间 -->
            <template slot="timeStart" slot-scope="text">
              {{ text | formatDate }}
            </template>

            <!-- 结束时间 -->
            <template slot="timeEnd" slot-scope="text">
              {{ text | formatDate }}
            </template>

            <!-- 时间 -->
            <template slot="createTime" slot-scope="text">
              {{ text | formatDate }}
            </template>
          </a-table>

          <Pagination
            :current="pagination.current"
            :total="pagination.total"
            :pageSize.sync="pagination.pageSize"
            :callback="getList"
            @change="getList"
            v-if="pagination.total > 0"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as API from '@/api/system/logs';
import { copyContent } from '@/libs/utils';
import { dragTableToScroll } from '@/libs/utils';

// 登录

export default {
  components: {},

  data() {
    return {
      copyContent,
      networkError: false,
      loading: true,
      tableLoading: false,
      // 搜索
      searchForm: {
        keyword: '',
        orderField: 0,
        orderType: 1,
        date: undefined,
      },

      endOpen: false,
      // 列表
      list: [],

      columns: [
        {
          title: this.$t('com_table_id'),
          align: 'center',
          dataIndex: 'id',
          width: 80,
        },

        {
          title: this.$t('logs_table_device_id'),
          dataIndex: 'devId',
          align: 'center',
        },
        {
          title: this.$t('com_table_status'),
          dataIndex: 'faultStatus',
          align: 'center',
          scopedSlots: { customRender: 'faultStatus' },
        },
        {
          title: this.$t('device_table_sn'),
          dataIndex: 'devSn',
          scopedSlots: { customRender: 'sn' },
        },

        {
          title: this.$t('logs_table_data'),
          dataIndex: 'data',
          scopedSlots: { customRender: 'executeData' },
        },

        {
          title: this.$t('logs_table_time_start'),
          dataIndex: 'timeStart',
          align: 'center',
          scopedSlots: { customRender: 'timeStart' },
        },

        {
          title: this.$t('logs_table_time_end'),
          dataIndex: 'timeEnd',
          align: 'center',
          scopedSlots: { customRender: 'timeEnd' },
        },

        {
          title: this.$t('com_table_type'),
          dataIndex: 'faultType',
          align: 'center',
          scopedSlots: { customRender: 'faultType' },
        },

        {
          title: this.$t('com_table_created_time'),
          dataIndex: 'createTime',
          align: 'center',
          scopedSlots: { customRender: 'createTime' },
        },
      ],
      // 分页
      pagination: {
        // 当前页码
        current: 1,
        // 每页显示
        pageSize: 20,
        // 记录总条数
        total: 0,
      },

      horizontalScroll: null,
    };
  },
  watch: {
    searchForm: {
      handler(form) {
        if (form.date && !form.date.length) {
          // 日期清空时调用
          this.getList();
        }
      },
      deep: true,
      immediate: true,
    },
  },

  created() {
    this.getList();
  },

  beforeDestroy() {
    this.horizontalScrollDestory();
  },
  methods: {
    getList(pageNo) {
      this.pagination.current = pageNo || 1;
      const params = {
        ...this.searchForm,
        pageNo: this.pagination.current,
        pageSize: this.pagination.pageSize,
      };

      if (this.searchForm.date && this.searchForm.date.length === 2) {
        params.date = `${this.searchForm.date[0]}-${this.searchForm.date[1]}`;
      } else {
        params.date = undefined;
      }

      this.tableLoading = true;
      this.networkError = false;

      console.log('params', params);

      // 获取列表
      API.DeviceFaultLog(params)
        .then(res => {
          this.loadSuccess(res);
        })
        .catch(err => {
          console.log('err', err);
          if (!/cancelled/gi.test(err)) {
            this.networkError = true;
          }
        })
        .finally(() => {
          this.loadComplete();

          // 表格横向滚动注册
          this.$nextTick(() => {
            this.horizontalScrollDestory();
            this.horizontalScroll = dragTableToScroll(
              document.querySelector('.ant-table-body'),
              document.querySelector('.ant-table-body table')
            );
          });
        });
    },

    // 横向滚动事件注销
    horizontalScrollDestory() {
      if (this.horizontalScroll) {
        this.horizontalScroll.destroy();
      }
    },

    loadComplete() {
      this.$store.commit('setPageLoading', false);
      this.loading = false;
      this.tableLoading = false;
    },

    // 成功
    loadSuccess(res) {
      this.list = res.data || [];

      // total
      this.pagination.total = res.totalCount;
    },

    disabledStartDate(startValue) {
      const endValue = this.searchForm.endTime;
      if (!startValue || !endValue) {
        return false;
      }
      return startValue.valueOf() > endValue.valueOf();
    },
    disabledEndDate(endValue) {
      const startValue = this.searchForm.startTime;
      if (!endValue || !startValue) {
        return false;
      }
      return startValue.valueOf() >= endValue.valueOf();
    },
    handleStartOpenChange(open) {
      if (!open) {
        this.endOpen = true;
      }
    },
    handleEndOpenChange(open) {
      this.endOpen = open;
    },
  },
};
</script>

<style lang="less" scoped>
.logs-nav {
  a {
    margin-right: 15px;
    color: #666;
    font-size: 12px;

    &.router-link-active {
      color: #1838d9;
      font-weight: bold;
    }
  }
}
</style>
